import { render, staticRenderFns } from "./VFormModified.vue?vue&type=template&id=297d6a41&scoped=true"
import script from "./VFormModified.vue?vue&type=script&lang=js"
export * from "./VFormModified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d6a41",
  null
  
)

export default component.exports